import memberManage from './memberManage'
export default memberManage
